export const convertPercentagesToNumber = (value) => {
  const valueWithoutPercentages = Number(value);

  return valueWithoutPercentages >= 1
    ? valueWithoutPercentages / 100
    : valueWithoutPercentages;
};
